import { Link } from '@mui/icons-material';
import { Box, SxProps, Typography } from '@mui/material';

import { DynamicTooltip } from 'shared/ui/Tooltip';

interface ColoredLinkBoxProps {
    color: string;
    tooltipText: string;
    sxProps?: SxProps;
}

export const ColoredLinkBox = ({
    color,
    tooltipText,
    sxProps,
    ...props
}: ColoredLinkBoxProps) => (
    <DynamicTooltip
        content={<Typography variant="caption">{tooltipText}</Typography>}
        enterDelay={200}
        offset={[0, 0]}
    >
        <Box
            sx={{
                ...sxProps,
                width: '24px',
                height: '24px',
                borderRadius: '2px',
                padding: '4px',
                bgcolor: color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            {...props}
        >
            <Link sx={{ fontSize: '1.8rem' }} />
        </Box>
    </DynamicTooltip>
);
